import { Box, Grid2, Link, Stack, Tooltip, Typography } from "@mui/material";
import { Heading } from "../../shared/ReusableComponents";
import { useEffect, useState } from "react";
import useGet from "../../services/hooks/useGet";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../store/currentPreferencesSlice";
import { apiEndpoints } from "../../shared/constants/api-constant";

interface ILinkItem {
  name: string | any;
  url: string;
}

export const Links = () => {
  const [links, setLinks] = useState<ILinkItem[]>([]);
  const { data, loading, getService } = useGet();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!data) {
      getService(apiEndpoints.SETTINGS);
    }

    const findData = data?.find((item: any) => item.name === "Links");
    if (findData) {
      try {
        const parsedList = JSON.parse(findData.value);
        setLinks(parsedList);
      } catch (err) {
        setLinks([]);
      }
    }
  }, [data]);

  useEffect(() => {
    loading && dispatch(showLoader());
    !loading && dispatch(hideLoader());
  }, [loading]);

  return (
    <div style={{ backgroundColor: "#fff", padding: "0px 0px 20px 0px" }}>
      <Heading
        text="Useful Resources"
        type="h5"
        style={{ marginLeft: "20px", padding: "20px 0px 0px 0px" }}
        isBold
      />
      {links.length === 0 ? (
        <Stack
          alignItems="center"
          justifyContent="center"
          fontSize="1rem"
          color={"var(--color-border-model)"}
        >
          No data available.
        </Stack>
      ) : (
        <Box
          component="ul"
          sx={{ listStyle: "none", paddingLeft: 0, marginLeft: "20px" }}
        >
          {links.map((link, index) => (
            <Box
              component="li"
              key={link.name || index}
              sx={{ display: "flex", alignItems: "center", mb: 0.5 }}
            >
              <Typography sx={{ color: "var(--color-info-main)", mr: 1 }}>
                {index + 1 + "."}
              </Typography>

              <Link
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{
                  color: "var(--color-info-main)",
                  maxWidth: "96%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                }}
              >
                <Tooltip title={link.name}>
                  <span>{link.name}</span>
                </Tooltip>
              </Link>
            </Box>
          ))}
        </Box>
      )}
    </div>
  );
};
